
import { MechanicalAspectEntityDecorator } from './mechanical-aspect.decorator';
import { MechanicalAspect } from './mechanical-aspect.model';
import { CrudTypeInfo } from '@scisys-uim/uim-common';


export abstract class MechanicalAspectTypeInfoBase implements CrudTypeInfo<MechanicalAspect, number> {
  name = 'Mechanical Aspect';
  entityDecorator = new MechanicalAspectEntityDecorator();
  
  createAuthorities = ['WRITE_MECHANICAL_ASPECT'];
  editAuthorities = ['WRITE_MECHANICAL_ASPECT'];
  deleteAuthorities = ['WRITE_MECHANICAL_ASPECT'];
  viewAuthorities = ['READ_MECHANICAL_ASPECT'];
  
  searchRouteBase = ['/mechanicalaspect/search'];
  createRouteBase = ['/mechanicalaspect/create'];
  editRouteBase = ['/mechanicalaspect/edit'];
  viewRouteBase = ['/mechanicalaspect/view'];
  
  description(item: MechanicalAspect): string {
    return '' +  item.aspectAssetId;
  }
}



